module.exports = function() {
  return new Worker(__webpack_public_path__ + "ed152fcb93afbf88069a.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/react-pdf/dist/pdf.worker.entry.js
// module id = 868
// module chunks = 1